import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-lg-18 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-lg-9 ant-col-xl-9" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-lg-9 ant-col-xl-9" }
const _hoisted_25 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_33 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_36 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_38 = {
  key: 3,
  class: "ant-row"
}
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-6" }
const _hoisted_44 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24"
}
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-lg-18 ant-col-xl-24" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "ant-row" }
const _hoisted_50 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4"
}
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_53 = { class: "ant-row" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_55 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_59 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_60 = { class: "ant-row" }
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-lg-14 ant-col-xl-14" }
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = { class: "ant-col ant-col-xs-24 ant-col-lg-3 ant-col-xl-3" }
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-lg-3 ant-col-xl-3" }
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "ant-row" }
const _hoisted_70 = { class: "ant-col ant-col-xs-24 ant-col-lg-14 ant-col-xl-14" }
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { class: "ant-col ant-col-xs-24 ant-col-lg-10 ant-col-xl-10" }
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = { class: "ant-row" }
const _hoisted_75 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-4" }
const _hoisted_76 = { class: "ant-col ant-col-xs-24 ant-col-lg-6 ant-col-xl-4" }
const _hoisted_77 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-16" }
const _hoisted_78 = ["onUpdate:modelValue"]
const _hoisted_79 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_combo_status_candidato = _resolveComponent("combo-status-candidato")!
  const _component_combo_genero = _resolveComponent("combo-genero")!
  const _component_combo_estado_civil = _resolveComponent("combo-estado-civil")!
  const _component_combo_mao_dominante = _resolveComponent("combo-mao-dominante")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_card = _resolveComponent("card")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_combo_grau_instrucao = _resolveComponent("combo-grau-instrucao")!
  const _component_combo_setor = _resolveComponent("combo-setor")!
  const _component_combo_tempo = _resolveComponent("combo-tempo")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_card, { titulo: "DADOS PESSOAIS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_a_form_item, { label: "CPF" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_cpf, {
                              valor: _ctx.state.candidato.cpf,
                              "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.candidato.cpf) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_form_item, { label: "RG/Identidade" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.candidato.rg) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.rg]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_form_item, { label: "PIS/NIT" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.candidato.pisNit) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.pisNit]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_a_form_item, { label: "Data Cadastro" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_data, {
                              horaMinuto: true,
                              dataSelecionada: _ctx.state.candidato.dataCadastro,
                              "onUpdate:dataSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.candidato.dataCadastro) = $event))
                            }, null, 8, ["dataSelecionada"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_a_form_item, { label: "Status no Sistema" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_status_candidato, {
                              valor: _ctx.state.candidato.status,
                              "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.candidato.status) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_a_form_item, { label: "Nome" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.candidato.nome) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.nome]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_a_form_item, { label: "Data Nascimento" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_data, {
                              dataSelecionada: _ctx.state.candidato.dataNascimento,
                              "onUpdate:dataSelecionada": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.candidato.dataNascimento) = $event))
                            }, null, 8, ["dataSelecionada"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, { label: "Local de nascimento" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.candidato.naturalidade) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.naturalidade]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_a_form_item, { label: "Nacionalidade" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.candidato.nacionalidade) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.nacionalidade]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    ((_ctx.storeApp.state.parceiroAutenticado.codigo === '2'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_a_form_item, { label: "Nome Pai" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.candidato.nomePai) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.nomePai]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_a_form_item, { label: "Nome Mãe" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.candidato.nomeMae) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.nomeMae]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_a_form_item, { label: "Gênero" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_genero, {
                              valor: _ctx.state.candidato.genero,
                              "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.candidato.genero) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_a_form_item, { label: "Estado Civil" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_estado_civil, {
                              valor: _ctx.state.candidato.estadoCivil,
                              "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.candidato.estadoCivil) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_a_form_item, { label: "Mão Dominante" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_mao_dominante, {
                              valor: _ctx.state.candidato.maoDominante,
                              "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.candidato.maoDominante) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_a_form_item, { label: "PCD - Possui Deficiência?" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_sim_nao, {
                              "radio-button": true,
                              valor: _ctx.state.candidato.possuiDeficiencia,
                              "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.candidato.possuiDeficiencia) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    ((_ctx.state.candidato.estadoCivil === 2 && _ctx.storeApp.state.parceiroAutenticado.codigo === '2'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_a_form_item, { label: "Nome Cônjuge" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.candidato.nomeConjuge) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.nomeConjuge]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_a_form_item, { label: "Local de Trabalho - Cônjuge" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.candidato.localTrabalhoConjugue) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.localTrabalhoConjugue]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.state.candidato.possuiDeficiencia))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_a_form_item, { label: "Deficiência" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.candidato.deficiencia) = $event)),
                                  placeholder: "Especifique sua deficiência"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.deficiencia]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.storeApp.state.parceiroAutenticado.codigo === '2'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_a_form_item, { label: "Transporte Utilizado" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.candidato.transporteUtilizado) = $event)),
                                  placeholder: "Descreva o transporte que você utiliza para ir trabalhar"
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.transporteUtilizado]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "INFORMAÇÕES PARA CONTATO" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_a_form_item, { label: "E-mail" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_email, {
                              valor: _ctx.state.candidato.email,
                              "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.candidato.email) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_a_form_item, { label: "Telefone" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.candidato.telefone,
                              "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.candidato.telefone) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_a_form_item, { label: "WhatsApp" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.candidato.whatsapp,
                              "onUpdate:valor": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.candidato.whatsapp) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      ((_ctx.storeApp.state.parceiroAutenticado.codigo === '2'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createVNode(_component_a_form_item, { label: "Nome do Colaborador que indicou" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.candidato.indicacaoColaborador) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.candidato.indicacaoColaborador]
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    ((_ctx.storeApp.state.parceiroAutenticado.codigo === '2'))
                      ? (_openBlock(), _createBlock(_component_card, {
                          key: 0,
                          titulo: "REFERÊNCIAS PESSOAIS"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "ui-button -primary ui-mh-32 ui-full",
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.adicionarReferenciaPessoal()))
                            }, " Adicionar Referência "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.candidato.referenciasPessoais, (referencia, index) => {
                              return (_openBlock(), _createBlock(_component_card, {
                                key: index,
                                titulo: (index + 1) + 'ª Referência'
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, [
                                      _createVNode(_component_a_form_item, { label: "Nome" }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            "onUpdate:modelValue": ($event: any) => ((referencia.nome) = $event)
                                          }, null, 8, _hoisted_47), [
                                            [_vModelText, referencia.nome]
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ]),
                                  _createElementVNode("button", {
                                    class: "ui-button -second ui-mh-32 ui-full",
                                    onClick: ($event: any) => (_ctx.removerReferenciaPessoal(index))
                                  }, " Remover Referência ", 8, _hoisted_48)
                                ]),
                                _: 2
                              }, 1032, ["titulo"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "ENDEREÇO/RESIDÊNCIA" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_49, [
                      ((_ctx.storeApp.state.parceiroAutenticado.codigo === '2'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createVNode(_component_a_form_item, { label: "Residência própria?" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_sim_nao, {
                                  "radio-button": true,
                                  valor: _ctx.state.candidato.residenciaPropria,
                                  "onUpdate:valor": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.candidato.residenciaPropria) = $event))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_a_form_item, { label: "CEP" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_cep, {
                              onBlur: _cache[26] || (_cache[26] = ($event: any) => (_ctx.consultaCep())),
                              valor: _ctx.state.candidato.cep,
                              "onUpdate:valor": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.candidato.cep) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.storeApp.state.parceiroAutenticado.codigo === '2'?'ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-12':'ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16')
                      }, [
                        _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.candidato.endereco) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.endereco]
                            ])
                          ]),
                          _: 1
                        })
                      ], 2),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_a_form_item, { label: "Número" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.candidato.numero) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.numero]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_a_form_item, { label: "Complemento" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.candidato.complemento) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.complemento]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_a_form_item, { label: "Bairro" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.candidato.bairro) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.candidato.bairro]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_cidade, {
                              codigo: _ctx.state.candidato.codigoCidade,
                              "onUpdate:codigo": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.candidato.codigoCidade) = $event))
                            }, null, 8, ["codigo"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "FORMAÇÕES E QUALIFICAÇÕES" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_a_form_item, { label: "Grau de Instrução" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_grau_instrucao, {
                              codigo: _ctx.state.candidato.grauInstrucao,
                              "onUpdate:codigo": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.candidato.grauInstrucao) = $event))
                            }, null, 8, ["codigo"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.storeApp.state.parceiroAutenticado.codigo === '2'?'Área Pretendida':'Setor Pretendido'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_setor, {
                              codigo: _ctx.state.candidato.codigoSetor,
                              "onUpdate:codigo": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.candidato.codigoSetor) = $event))
                            }, null, 8, ["codigo"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createVNode(_component_card, { titulo: "CURSOS" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "ui-button -primary ui-mh-32 ui-full",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.adicionarCurso()))
                        }, " Adicionar Curso "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.candidato.cursos, (curso, index) => {
                          return (_openBlock(), _createBlock(_component_card, {
                            key: index,
                            titulo: (index + 1) + 'º Curso'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createVNode(_component_a_form_item, { label: "Curso" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": ($event: any) => ((curso.curso) = $event)
                                      }, null, 8, _hoisted_62), [
                                        [_vModelText, curso.curso]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createVNode(_component_a_form_item, { label: "Duração" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "ant-input",
                                        "onUpdate:modelValue": ($event: any) => ((curso.duracao) = $event)
                                      }, null, 8, _hoisted_64), [
                                        [_vModelText, curso.duracao]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _createVNode(_component_a_form_item, { label: "Tempo" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_combo_tempo, {
                                        valor: curso.tempo,
                                        "onUpdate:valor": ($event: any) => ((curso.tempo) = $event)
                                      }, null, 8, ["valor", "onUpdate:valor"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _createVNode(_component_a_form_item, { label: "Ano de Conclusão" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "ant-input",
                                        "onUpdate:modelValue": ($event: any) => ((curso.anoConclusao) = $event)
                                      }, null, 8, _hoisted_67), [
                                        [_vModelText, curso.anoConclusao]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createElementVNode("button", {
                                class: "ui-button -second ui-mh-32 ui-full",
                                onClick: ($event: any) => (_ctx.removerCurso(index))
                              }, " Remover Curso ", 8, _hoisted_68)
                            ]),
                            _: 2
                          }, 1032, ["titulo"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "EXPERIÊNCIAS PROFISSIONAIS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "ui-button -primary ui-mh-32 ui-full",
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.adicionarExperienciaProfissional()))
                    }, " Adicionar Experiência "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.candidato.experienciaisProfissionais, (experiencia, index) => {
                      return (_openBlock(), _createBlock(_component_card, {
                        key: index,
                        titulo: _ctx.obtemTituloExperiencia(index)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(_component_a_form_item, { label: "Empresa" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((experiencia.empresa) = $event)
                                  }, null, 8, _hoisted_71), [
                                    [_vModelText, experiencia.empresa]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _createVNode(_component_a_form_item, { label: "Cargo" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((experiencia.cargo) = $event)
                                  }, null, 8, _hoisted_73), [
                                    [_vModelText, experiencia.cargo]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createVNode(_component_a_form_item, { label: "Data Admissão" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    dataSelecionada: experiencia.dataAdmissao,
                                    "onUpdate:dataSelecionada": ($event: any) => ((experiencia.dataAdmissao) = $event)
                                  }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _createVNode(_component_a_form_item, { label: "Data Saída" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data, {
                                    dataSelecionada: experiencia.dataSaida,
                                    "onUpdate:dataSelecionada": ($event: any) => ((experiencia.dataSaida) = $event)
                                  }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createVNode(_component_a_form_item, { label: "Motivo Saída" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((experiencia.motivoSaida) = $event)
                                  }, null, 8, _hoisted_78), [
                                    [_vModelText, experiencia.motivoSaida]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "ui-button -second ui-mh-32 ui-full",
                            onClick: ($event: any) => (_ctx.removerExperienciaProfissional(index))
                          }, " Remover Experiência ", 8, _hoisted_79)
                        ]),
                        _: 2
                      }, 1032, ["titulo"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}